// extracted by mini-css-extract-plugin
export var container = "_9g-0";
export var icon = "_9g-1";
export var text = "_9g-2";